import React, { Component } from 'react'
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { intComma } from 'humanize-plus'
import Icon from 'svg-inline-react'

import CompanyInfoField from './CompanyInfoField'
import CompanyInfoProvider from "./CompanyInfoProvider"

import * as RevealSelectors from 'app/modules/reveal/selectors'
import * as RevealActions from 'app/modules/reveal/actions'

import ConditionalRender from 'components/shared/ConditionalRender'
import Social from "components/shared/ContactRecordLite/Social"
import { AvatarCompat } from 'components/shared/AvatarCompat'
import DEFAULT_AVATAR from '!svg-inline?removeTags=true!images/live/default-company-logo.svg'

import './style.styl'


class NewCompanyInfo extends Component {

  componentDidMount() {
    this.props.actions.fetchReveal({ endUserId: this.props.endUserId })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.endUserId !== nextProps.endUserId) {
      this.props.actions.fetchReveal({ endUserId: this.props.endUserId })
    }
  }

  getSources(sourceData) {
    const toSource = (datum) => datum && datum.source
    return _.chain(sourceData)
      .mapValues(toSource)
      .filter(_.identity)
      .uniq()
      .value()
  }

  render() {
    const companyInfo = _.get(this.props.companyInfo,'value.companyData',{})
    const explainData = _.get(this.props.companyInfo,'explain.companyData',{})
    const location = _.get(companyInfo, 'address', '-')
    const category = _.get(companyInfo, 'industry', '-')
    const subCategory = _.get(companyInfo, 'subIndustry', '-') || '-'
    const linkedin = _.get(companyInfo, 'linkedinHandle')
    const employees = _.get(companyInfo, 'employeeCount', '-')
    const raised = _.get(companyInfo, 'raised', '-')
    const twitter = _.get(companyInfo, 'twitterHandle',)
    const about = _.get(companyInfo, 'description', '-')
    const revenueRange = _.get(companyInfo, 'revenueRange', '-')
    const sources = this.getSources(explainData)
    const url = _.get(companyInfo, 'url')
    const logo = _.get(companyInfo, 'logo')
    const domain = _.get(companyInfo, 'domain')
    const tags = _.union(_.get(companyInfo, 'techTags'), _.get((companyInfo,'companyTags')))

    const canUseCompanyTags = this.props.canUseCompanyTags

    const companyLogo = (!!logo ?
        <AvatarCompat company={{ name, logo }} type="company" size="small"/> :
        <div className="contact-info-header-logo">
          <Icon src={DEFAULT_AVATAR}/>
        </div>
    )
    const companyProvider = <CompanyInfoProvider provider={sources}/>

    const companyLink = _.includes(url, 'http') ? url : `http://www.${domain}`
    
    return (
      <div className="scrolly-content">
        <div className="company-info-header">
          <div className="company-info-header-left">
            {companyLogo}
          </div>
          <div className="company-info-header-right">
            <div className="company-info-title">{name}</div>
            <a href={companyLink} target="_blank" className="company-info-url"><span>{domain}</span></a>
            <div className="company-info-social">
              {!!twitter && <Social type="twitter" handle={twitter} className="company-info-social-icon"/>}
              {!!linkedin && <Social type="linkedin" handle={linkedin} className="company-info-social-icon"/>}
            </div>
          </div>
        </div>
        <div className="company-info-content">
          <div className="company-info-content-left">
            <CompanyInfoField primary={location} secondary="location"/>
            <CompanyInfoField primary={category} secondary="category"/>
            <CompanyInfoField primary={subCategory} secondary="subcategory"/>
            <ConditionalRender condition={canUseCompanyTags}>
              <CompanyInfoField primary={tags.join(', ')} secondary="tags"/>
            </ConditionalRender>
          </div>

          <div className={"company-info-content-right"}>
            <CompanyInfoField primary={employees} secondary="employees"/>
            {sources.includes('DEMANDBASE_OEM') && <CompanyInfoField primary={revenueRange} secondary="revenue range"/>}
            {sources.includes('CLEARBIT_OEM') && <CompanyInfoField primary={`$${intComma(raised)}`} secondary="money raised"/>}
          </div>
          <div className="company-info-content-divider"/>
          <CompanyInfoField primary={about} secondary="about"/>
        </div>
        {!!companyProvider && (
          <div className="company-info-footer">
            {companyProvider}
          </div>
        )}
      </div>)
  }
}

const makeMapStateToProps = () => {
  return (state, props) => {
    const revealData = RevealSelectors.makeGetEndUserReveal()

    return {
      companyInfo: revealData(state, { endUserId: props.endUserId, orgId: props.orgId }),
      canUseCompanyTags: props.canUseCompanyTags,
      orgId: props.orgId
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    fetchReveal: RevealActions.fetchRevealDataBySourceProperties
  }, dispatch),
})

export default connect(makeMapStateToProps, mapDispatchToProps)(NewCompanyInfo)



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/newCompanyInfo.js